import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EidasUser } from '../_model/eidasUser';
import { JwtUtilsService } from '../_service/jwt-utils.service';
import { AccessPointService } from '../_service/access-point.service';
import { EidasService } from '../_service/eidas-service.service';
import { Dialog } from '@angular/cdk/dialog';
import { MatDialogConfig } from '@angular/material/dialog';
import { AgreementComponent } from '../agreement/agreement.component';
import { TranslateService } from '@ngx-translate/core';
import { StateService } from '../_service/state.service';
import { MultiLanguageStringPipe } from '../_model/multi-language-string';
import { QueryRequestDataDto } from '../_model/queryRequestData';
import { ModalDialogService } from '../_service/modal-dialog.service';
import { ModalDialogComponent } from '../_common/modal-dialog/modal-dialog.component';
import { COUNTRIES } from '../contants';
import { PreviewSpaceResponse, ResponseErrorType } from '../_model/preview-space-response';
import { PreviewService } from '../_service/preview.service';
import { Utils } from '../_common/utils';
import { RequestStatusEnum } from '../_model/request-status-enum';
import { SessionTimerService } from '../_service/session-timer.service';
import { BreadcrumbService } from '../_service/breadcrumb.service';
import { environment } from 'src/environments/environment';

declare const require: any;
const i18nIsoCountries = require("i18n-iso-countries");
@Component({
  selector: 'app-preview-space',
  templateUrl: './preview-space.component.html',
  styleUrls: ['./preview-space.component.css']
})
export class PreviewSpaceComponent implements OnInit {

  isUserLogged: boolean;
  isValidSession: boolean;
  currentUser: EidasUser;
  pdfLink = ""
  requestId: string;
  returnUrl: string;
  session: string;
  selectedLanguage: string;
  isChecked = false;
  requestInfo: QueryRequestDataDto;
  countries: any;
  sessionStatus: string;
  step: number;
  isRedirecting = false;

  constructor(
    private route: ActivatedRoute,
    private jwtUtilService: JwtUtilsService,
    private eidasService: EidasService,
    private apService: AccessPointService,
    private dialog: Dialog,
    public translate: TranslateService,
    private multiLanguagePipe: MultiLanguageStringPipe,
    private stateService: StateService,
    private dialogService: ModalDialogService,
    private previewService: PreviewService,
    private sessionTimerService: SessionTimerService,
    private breadcrumbService: BreadcrumbService,
  ) {}

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event: any): void {
    if(!this.isRedirecting && !this.isUserLogged && !this.jwtUtilService.getRedirect()){
      this.sendClosureError();
    }
  }

  ngOnInit(): void {
    const params = this.route.snapshot.queryParams;
    this.session = params['session'];
    this.returnUrl = params['returnurl'];
    if (this.session != undefined) {
      window.localStorage.setItem('session', this.session);
      window.localStorage.setItem('returnurl', this.returnUrl);
      this.requestId = this.session;
    } else {
      this.session = window.localStorage.getItem('session') ?? "";
      this.requestId = window.localStorage.getItem('session') ?? "";
      this.returnUrl = window.localStorage.getItem('returnurl') ?? "";
    }
    this.isUserLogged = this.jwtUtilService.getCurrentUser() !== undefined;
    this.jwtUtilService.saveRedirect('false');
    this.breadcrumbService.getStep.subscribe(step => this.step = step);
    this.validateSession(this.session);
  }

  agreementChange(event: any) {
    this.stateService.agreementAccepted = this.isChecked;
  }

  acceptOrDenyEvidence(accept: boolean) {
    console.log("peticionId: " + this.requestId + " accept: " + accept);
    this.previewService.sendResponse(this.session).subscribe(
      {
        next: result => {
          console.log(result);
          this.navigateBack();
        },
        error: (e) => {
          console.error(e)
          this.navigateBack();
        },
        complete: () => {
          console.log("completed")
          this.navigateBack();
        }
      }
    );
    
  }

  validateSession(session: string) {
    this.previewService.isValidSession(session).subscribe(requestSessionStatus => {
      console.log(requestSessionStatus);
      this.sessionStatus = requestSessionStatus.toString();

      switch (requestSessionStatus.toString()) {

        case 'NOT_FOUND':
          this.retrySearch(session);
          break;

        case 'PENDING':
          this.eidasService.getRequestDataInfoDto(session).subscribe(
            {
              next: result => {
                console.log(result);
                this.requestInfo = result;
              },
              error: (e) => {
                console.error("Error" + e)
              },
              complete: () => {
                console.log("completed")
              }
            });

          this.isValidSession = true;
          break;

        case 'OBTAINED':
          this.eidasService.getRequestDataInfoDto(session).subscribe(
            {
              next: result => {
                console.log(result);
                this.requestInfo = result;
              },
              error: (e) => {
                console.error("Error" + e)
              },
              complete: () => {
                console.log("completed")
              }
            });

          this.updateStep(2)
          this.isValidSession = true;

          break;


        case 'EXPIRED':
        case 'REQUESTED':
        case 'PROCESSED':
          this.isValidSession = true;
          break;
        case undefined:
          this.eidasService.getRequestDataInfoDto(session).subscribe(
            {
              next: result => {
                console.log(result);
                this.requestInfo = result;
              },
              error: (e) => {
                console.error("Error" + e)
              },
              complete: () => {
                console.log("completed")
              }
            });
      }
    });
  }

  retrySearch(session: string) {
    let reintentos = 10;
    const interval = setInterval(() => {
      const remainingTime = reintentos;
      if (remainingTime > 0) {
        reintentos = reintentos - 1
        this.previewService.isValidSession(session).subscribe(requestSessionStatus => {
          this.sessionStatus = requestSessionStatus.toString();
          console.log(requestSessionStatus);

          switch (requestSessionStatus) {
            case RequestStatusEnum.NOT_FOUND:
              break;

            case RequestStatusEnum.OBTAINED:
              reintentos = 0;
              this.updateStep(2);
              this.isValidSession = true;
              break;

            case RequestStatusEnum.PENDING:
              this.isValidSession = true;
              this.apService.obtainEvidence(session).subscribe(data => {
                console.log(data);
                this.pdfLink = data
                reintentos = 0;
              })
              break;

            case RequestStatusEnum.REQUESTED:
            case RequestStatusEnum.EXPIRED:
            case RequestStatusEnum.PROCESSED:
              reintentos = 0;
              this.isValidSession = true;
              break;
          }

        });
      } else {
        this.dialogService.closeDialog();
        if (this.isValidSession) {
          clearInterval(interval);
          this.openPreviewDialog();
        }

      }
    }, 1000);
  }

  openLoadingDialog() {
    const data = {
      title: this.translate.instant('PREVIEW_SPACE.LOADING'),
      message: this.translate.instant('PREVIEW_SPACE.REQ_LOAD'),
      type: 'loading-modal'
    }
    this.dialogService.openDialog(ModalDialogComponent, data).subscribe();
  }

  openPreviewDialog() {
    const data = {
      title: this.translate.instant('PREVIEW_SPACE.REQ2_ERR'),
      message: this.translate.instant('PREVIEW_SPACE.REQ2_MESS', { document_name: this.requestInfo.listRequirementNames[0] ?? "", provider: this.transformTexts(this.requestInfo.requesterName, 'EN') }),
      toAsset: COUNTRIES[this.requestInfo.country.value] ?? COUNTRIES['EU'],
      type: 'preview-error-redirect'
    };

    this.dialogService.openDialog(ModalDialogComponent, data)
      .subscribe(result => {
        if (result?.action === 'accept') {
          this.sendRequest2Error();
        } else if (result?.action === 'cancel') {
          this.validateSession(this.session);
        }
      });
  }

  navigateBack() {
    this.isRedirecting = true;
    window.location.href = this.returnUrl;

    //This code is just for the oots_ap_es - oots_ap_es flow and should be deleted on final version or when its not needed
    if(!(this.transformTexts(this.requestInfo.requesterName,'EN') === "Spanish Tax Administration Agency" && (environment.api_url == "https://oots.simplegob.com/intermediaryapp" || environment.api_url == "http://localhost:8080"))){
      this.sessionTimerService.endSessionOnClose();
    }
    // And this code section should be uncommented
    // this.sessionTimerService.endSessionOnClose();
  }

  openAgreementDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { top: '50%', left: '50%' };
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      title: this.translate.instant('PREVIEW_SPACE.TERMS_AND_CONDITIONS_1'),
      message: this.translate.instant('PREVIEW_SPACE.TERMS_AND_CONDITIONS_2'),
    };
    const dialogRef = this.dialog.open(AgreementComponent, dialogConfig);
    dialogRef.closed.subscribe(result => {
      window.sessionStorage.setItem('agreementAccepted', 'true');
    });
  }
  transformTexts(collection: any[], lang: string) {
    i18nIsoCountries.registerLocale(require("i18n-iso-countries/langs/es.json"));
    const translatedStr = this.multiLanguagePipe.transform(collection, lang) ?? "";
    return translatedStr;
  }

  changeCountryLanguage(countryCode: string | null, lang: string) {
    if (!Utils.hasValue(countryCode)) return "";
    const countryName = i18nIsoCountries.getName(countryCode, lang);
    if (countryName === undefined) {
      return countryCode;
    }
    else {
      return countryName;
    }
  }

  goToLink(link: string) {
    window.open(link, "_blank");
  }

  handleResponseEidas(isRedirect: boolean) {
    if (isRedirect) {
      this.sendUserMismatchError()
    }
    else {
      this.isUserLogged = false;
    }
  }

  sendRequest2Error() {
    const response = new PreviewSpaceResponse();
    response.errorMessage = "The second request was not received'"
    response.errorType = ResponseErrorType.INVALID_REQUEST;
    response.session = this.session;
    this.returnError(response);
  }

  sendUserMismatchError() {
    const response = new PreviewSpaceResponse();
    response.errorMessage = "Unable to match logged in user with QueryRequest natural person"
    response.errorType = ResponseErrorType.AUTHENTICATION;
    response.session = this.session;
    this.returnError(response);
  }

  sendClosureError() {
    const response = new PreviewSpaceResponse();
    response.errorMessage = "Tab has been closed unexpectedly by the user"
    response.errorType = ResponseErrorType.SESSION_TIMEOUT;
    response.session = this.session;
    this.returnError(response);
  }

  returnError(response: PreviewSpaceResponse) {
    this.previewService.returnError(response).subscribe({
      next: data => {
        this.navigateBack();
      },
      error: errorContent => {
        console.log(errorContent);
      }

    },);
  }

  updateStep(newStep: number) {
    this.breadcrumbService.setStep(newStep)
  }
}